import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { UserService } from '../../../../_services/index';
import { CommonService }  from '../../service/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'expediusa-shared-notification',
    templateUrl: './notification.component.html',
	styleUrls : ['./notification.component.css'],
	providers: [UserService,CommonService]
	
})

  
export class NotificationComponent implements OnInit, OnDestroy {

	/**This is used to prevent memory leaks **/
	private ngUnsubscribe: Subject<void> = new Subject<void>();
	/**This is used to prevent memory leaks **/

	env		  =	environment;
	isLoading : boolean = false;
	result	  : boolean = false;
    notificationData : any = [];
	current_page    	: number  	=  1;
	total_record    	: number  	=  0;
	limit           	: number  	= 10;

	// Declare Constructor
	constructor(private commonService : CommonService, public userService:UserService) {
		/**this function is used to get notifications*/
		this.getNotification();
		/**this function is used to get notifications*/
	}

	// Declare initialization
	ngOnInit(): void  {}
	
	/**this function is used to get notifications*/
    public getNotification(){
		this.isLoading = true;
		let req : any = {};
		req['data'] = {};
		req['data']['skip']  = ((this.current_page - 1)*this.limit);
		req['data']['limit'] = this.limit;
		req['data']['user_id'] = this.userService.getCurrentUser()._id;
		this.commonService.getNotifications(req).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
			if (response.status === this.env.SUCCESS_STATUS) {
				this.notificationData	= response.notifications;
				this.result =  response.notifications.length ? true : false;
				this.total_record = response.recordsTotal;
				this.isLoading = false;
			}
		});
	}
	/**this function is used to get notifications*/

	/** This function is used to handle the current page	*/
	public goToPage(n: number): void {		
		this.current_page = n;
		this.getNotification();		
		let pos = window.pageYOffset;
		if (pos > 0) {
			window.scrollTo(0, 100); // how far to scroll on each step
		} 
	} 
	/** This function is used to handle the current page	*/

	/** This function is used to handle the paging and show the next page */
	public onNext(): void {		
		this.current_page++;
		this.getNotification();	
		let pos = window.pageYOffset;
		if (pos > 0) {
			window.scrollTo(0, 100); // how far to scroll on each step
		} 
	}
	/** This function is used to handle the paging and show the next page */
	
	/** This function is used to handle the paging and show the previous page */
	public onPrev(): void {		
		this.current_page--;
		this.getNotification();	
		let pos = window.pageYOffset;
		if (pos > 0) {
			window.scrollTo(0, 100); // how far to scroll on each step
		} 
	} 
	/** This function is used to handle the paging and show the previous page */

	/**This function are used for destroy the data**/
	ngOnDestroy(): void {
		this.ngUnsubscribe.next();
	}
	/**This function are used for destroy the data**/

	
}
